





















































































































import { Vue, Component, Prop } from "vue-property-decorator";
import LectureCourseSelect from "@/components/lectures/LectureCourseSelect.vue";
import LecturePages from "@/components/lectures/LecturePagesCreate.vue";
import LectureSlideCreate from "@/components/lectures/LectureSlideCreate.vue";
import LectureVideoCreate from "@/components/lectures/LectureVideoCreate.vue";
import LectureExtraMaterialCreate from "@/components/lectures/LectureExtraMaterialCreate.vue";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { Lecture as ILecture } from "@/api/models/lecture";

//---------СТРАНИЦЫ ЛЕКЦИИ-----------//
import { LecturePages as ILecturePages } from "@/api/models/lecture-pages";
import { LecturePageCreate as ILecturePageCreate } from "@/api/models/lecture-page-create";
import { LecturePage as ILecturePage } from "@/api/models/lecture-page";
import { LectureEdit as ILectureEdit } from "@/api/models/lecture-edit";
//---------СТРАНИЦЫ ЛЕКЦИИ-----------//

//---------СЛАЙДЫ ЛЕКЦИИ-----------//
import { LectureSlideCreate as ILectureSlideCreate } from "@/api/models/lecture-slide-create";
import { LectureSlideEdit as ILectureSlideEdit } from "@/api/models/lecture-slide-edit";
//---------СЛАЙДЫ ЛЕКЦИИ-----------//

import { LectureVideo as ILectureVideo } from "@/api/models/lecture-video";
import { LectureVideoEdit as ILectureVideoEdit } from "@/api/models/lecture-video-edit";
import { LectureVideoCreate as ILectureVideoCreate } from "@/api/models/lecture-video-create";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { LectureExtraMaterialCreate as ILectureExtraMaterialCreate } from "@/api/models/lecture-extra-material-create";
import Modal from "@/components/form/Modal.vue";
import LectureEntityFormList from "@/components/lectures/LectureEntityFormList.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import { LearningMaterialLocales } from "@/plugins/custom-interface";

// TODO: Добавить слайды и доп. материалы после реализации добавления файлов
@Component({
  components: {
    CSingleSelect,
    CustomButton,
    Modal,
    LectureEntityFormList,
    LectureExtraMaterialCreate,
    LectureVideoCreate,
    LectureCourseSelect,
    LecturePages,
    LectureSlideCreate
  }
})
export default class LectureFormEdit extends Vue {
  @Prop() lectureInfo!: ILecture;
  hours?: number;
  title: string = "";
  companyId: string = "";
  ownerId: string = "";
  description!: string;
  enabled: boolean = false;
  sort!: number;
  videos!: ILectureVideoCreate;
  lecturePages!: Array<ILecturePageCreate>;
  editFormLecturePages?: Array<ILecturePages>;
  existLecturesPage!: Array<ILecturePage>;
  lecturePageDelete!: Array<string>;
  lectureSlidesDelete!: Array<string>;
  lectureVideoDelete!: Array<string>;
  slides: any = [];
  lectureSlide!: Array<ILectureSlideCreate>;
  lectureVideo: Array<ILectureVideoCreate | ILectureVideo> = [];
  extraMaterial!: ILectureExtraMaterialCreate;
  isSaveProcessing: boolean = false;
  employees!: EmployeesListClass;
  locale: string = "";

  data() {
    return {
      lecturePages: [], //Страница лекции
      selectedCourse: [], //Выбранный курс
      editFormLecturePages: undefined,
      existLecturesPage: [],
      lecturePageDelete: [],
      lectureSlidesDelete: [],
      extraMaterial: undefined,
      lectureVideoDelete: [],
      employees: undefined,
      hours: 0
    };
  }

  deleteLecture() {
    api.LectureApi._delete(this.lectureInfo.id)
      .then(() => {
        this.$router.push({ name: "lectureList" });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get locales() {
    return LearningMaterialLocales();
  }

  existVideosToDelete(item: Array<string>) {
    this.lectureVideoDelete = item;
  }

  addLecturePage(lecturePages: Array<ILecturePageCreate>) {
    this.lecturePages = lecturePages;
  }

  createExtraMaterial(extraMaterial: ILectureExtraMaterialCreate) {
    this.extraMaterial = extraMaterial;
  }

  editExistLecturePage(existLecturePageEditable: Array<ILecturePage>) {
    this.existLecturesPage = existLecturePageEditable;
    this.$emit("refreshProps");
  }

  idsLecturePageToDelete(idsToDelete: Array<string>) {
    this.lecturePageDelete = idsToDelete;
  }

  existSlideToDelete(item: Array<string>) {
    this.lectureSlidesDelete = item;
  }

  editLectureSlide(lectureSlide: Array<ILectureSlideCreate>) {
    this.lectureSlide = lectureSlide;
  }

  addLectureVideo(lectureVideo: Array<ILectureVideoCreate>) {
    this.lectureVideo = lectureVideo;
    this.editVideoSort();
  }

  getSlide(item: any) {
    this.slides = item;
    this.editSortSlide();
  }

  async editVideoSort() {
    await Promise.all(
      this.lectureVideo.map(async (video: any) => {
        if (video.id) {
          let params: ILectureVideoEdit = {
            sort: video.sort
          };
          api.LectureVideoApi.edit(this.lectureInfo.id, video.id, params);
        }
      })
    );
  }

  async editSortSlide() {
    await Promise.all(
      this.slides.map(async (slide: any) => {
        if (slide.id) {
          let params: ILectureSlideEdit = {
            sort: slide.sort
          };
          api.LectureSlideApi.edit(this.lectureInfo.id, slide.id, params);
        }
      })
    );
  }

  submit() {
    this.isSaveProcessing = true;
    if (this.lectureSlidesDelete.length) {
      this.lectureSlidesDelete.forEach(element => {
        api.LectureSlideApi._delete(this.lectureInfo.id, element);
      });
    }

    if (this.lectureVideo.length) {
      this.lectureVideo.forEach(element => {
        //@ts-ignore
        if (!element.id) {
          const arg: ILectureVideoCreate = {
            title: element.title,
            body: element.body ? element.body : "",
            sort: element.sort
          };
          api.LectureVideoApi.create(this.lectureInfo.id, arg);
        }
      });
    }

    if (this.slides && this.slides.length) {
      this.slides = this.slides.forEach((element: any, index: number) => {
        element.sort = index + 1;
        if (!element.id) {
          let imgArray: Array<string> = [];
          element.images.forEach((img: any) => {
            imgArray.push(img.id);
          });

          let params: ILectureSlideCreate = {
            sort: element.sort,
            body: element.body,
            images: imgArray
          };
          api.LectureSlideApi.create(this.lectureInfo.id, params);
        }
      });
    }

    if (this.extraMaterial)
      api.LectureExtraMaterialApi.create(
        this.lectureInfo.id,
        this.extraMaterial
      );

    if (this.lecturePages.length > 0) {
      this.lecturePages.forEach(element => {
        const lecturePage: ILecturePageCreate = {
          body: element.body,
          sort: element.sort
        };
        api.LecturePageApi.create(this.lectureInfo.id, lecturePage);
      });
    }

    if (this.lectureVideoDelete.length) {
      this.lectureVideoDelete.forEach(element => {
        api.LectureVideoApi._delete(this.lectureInfo.id, element);
      });
    }

    if (this.lecturePageDelete) {
      this.lecturePageDelete.forEach(element => {
        api.LecturePageApi._delete(this.lectureInfo.id, element);
      });
    }
    let lecture: ILectureEdit = {
      title: this.title,
      ownerId: this.ownerId,
      description: this.description,
      enabled: this.enabled,
      hours: this.hours || 0,
      locale: this.locale ?? ""
    };
    api.LectureApi.edit(this.lectureInfo.id, lecture)
      .then(() => {
        this.$router.push({
          name: "lecture",
          params: { id: this.lectureInfo.id }
        });
      })
      .catch((error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
        if (error.response) {
          this.$bvToast.toast(`${error.response.data.message}`, {
            variant: "danger",
            title: this.$tc(this.$translate.Error)
          });
        }
      })
      .finally(() => {
        this.isSaveProcessing = true;
      });
  }

  getEmployees() {
    this.employees = new EmployeesListClass({
      id: this.companyId,
      roles: ["content_manager"],
      limit: 200
    });
  }

  mounted() {
    if (this.lectureInfo) {
      this.title = this.lectureInfo.title;
      this.companyId = this.lectureInfo.companyId;
      this.editFormLecturePages = this.lectureInfo.pages;
      this.enabled = this.lectureInfo.enabled;
      this.ownerId = this.lectureInfo.ownerId;
      this.hours = this.lectureInfo.hours;
      this.locale = this.lectureInfo.locale ? this.lectureInfo.locale : "";

      this.getEmployees();
      // this.getEditLecturePages();
    }
  }

  getEditLecturePages() {
    if (this.editFormLecturePages) {
      this.editFormLecturePages.forEach(element => {
        api.LecturePageApi.get(this.lectureInfo.id, element.id)
          .then((res: { data: ILecturePage }) => {
            if (res.data) {
              this.existLecturesPage.push(res.data);
            }
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      });
    }
  }
}
